module.exports = __webpack_public_path__ + "img/issuance-cost-1.b9047494.png";